import { inject } from "@angular/core";

import { SignUpNavigationService } from "./navigation.service";
import { ApiSessionService } from "../../../../common/services/api/api-session.service";

export const SignUpFailedGuard = () => {
  const apiSession = inject(ApiSessionService);
  const navigate = inject(SignUpNavigationService);

  if (!apiSession.isLoggedIn()) {
    return true;
  } else {
    navigate.handleFailedGuardRoute();
    return false;
  }
};
